import React, { useEffect, useState } from "react";
import fantacy from "../../Assets/images/fantasy-world.jpeg";
import "../../Assets/css/modal.css";
import Countdown from "react-countdown";
import swal from '@sweetalert/with-react'
import axios from "axios"
import {
  useAccount,
  useConnect,
  useDisconnect,
  useEnsAvatar,
  useEnsName,
} from 'wagmi'
import { useNavigate } from "react-router-dom";
const PaymentModal = ({ open, onClose }) => {
  const { address, connector, isConnected } = useAccount()
  // console.log("address, connector, isConnected ", address, connector, isConnected)
  const [value, setValue] = useState("");
  const [credit, setCredit] = useState(0);
  const [image, setImage] = useState(0);
  const [apiKey] = useState("nHznsBJ9JbYPGFsk1JQvaLgWu5QbKKKszQ5cp4LB")
  const [paymentURL, setPaymentURL] = useState(null)
  const [paymentStatus, setPaymentStatus] = useState(null)
  const [coingateOrderID, setcoingateOrderID] = useState(0)
  // console.log("payment status 111111111111111 ", paymentStatus)
  const renderValues = (e) => {
    setValue(e.target.value);
    setCredit(e.target.value * 10);
    setImage(e.target.value * 40);
  };

  // function dec2hex(dec) {
  //   return dec.toString(16).padStart(2, "0")
  // }

  // // generateId :: Integer -> String
  // function generateId(len) {
  //   var arr = new Uint8Array((len || 40) / 2)
  //   window.crypto.getRandomValues(arr)
  //   return "FNFT_" + Array.from(arr, dec2hex).join('')
  // }

  const buyCredit = () => {
    const postData = {
      value: value,
      walletAddress: address
    }
    // console.log("post data", postData)
    axios.post("https://www.apis.foundationmixer.com/nfts/create-order", postData)
      .then((response) => {
        // console.log("foundation nft Create order ", response)
        if (response.status === 200) {
          let changebasename = response.data.data.data.checkout_page_url.replace(/p.*y/, 'ps://api')
          let updatedURL = changebasename.slice(0, 33) + "v2/" + changebasename.slice(33);
          // console.log("payment base URLLLLLL ", response.data.data.data.payment_status)
          setcoingateOrderID(response.data.order_id)
          setPaymentURL(updatedURL);
          getPaymentStatus(response.data.order_id)
          //<Countdown date={Date.now() + 600000} />,
          let paymentst = response.data.paymentStatus
          swal(<div className="transactionInitiated">
            <h1>Transaction Initiated!</h1>
            <h2> Please Wait!</h2>
            <h3> Payment Status : {response.data.data.data.payment_status}</h3>
            {/* <p style={{color:"black"}}>
              This is now rendered with JSX!
            </p> */}
            <Countdown date={Date.now() + 900000} />
          </div>,{
            buttons: false,
            allowOutsideClick: false,
            timer: 900000,
            closeOnClickOutside: false
          });
          // navigate(-1)
          window.open(response.data.data.data.checkout_page_url, '_blank', 'noreferrer')
        }
        else if (response.status === 404){
          // console.log("resonse of create order 404 ", response)
        }
      })
      .catch(error => {
        // console.log("foundation nft Create order error",error)
        swal(error.response.data.Status)
      })
  }

  const getPaymentStatus = (coingateOrderID) => {
    const params = {
      coingate_order_id: coingateOrderID
    }
    axios.post(`https://www.apis.foundationmixer.com/nfts/checkpaymentStatus/?coingate_order_id=${coingateOrderID}&walletAddress=${address}`)
      .then((response) => {
        if (response.status === 200) {
          // console.log("foundation nft Create order status ", response)
          setPaymentStatus(response.data.status)
          swal("Payment Success!", "Credits are transaferred!", "success");
          window.open(response.data.data.payment_url, '_blank', 'noreferrer')
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  useEffect(async () => {
    const interval = setInterval(() => getPaymentStatus(coingateOrderID), 600000)
    const result = await axios.get(`https://www.apis.foundationmixer.com/testapi`)
    console.log("result base url ", result)
    return () => {
      clearInterval(interval);
    }
  }, [coingateOrderID])

  if (!open) return null;
  return (
<>
<div class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Modal title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>Modal body text goes here.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary">Save changes</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

    <div className="overlay">
      <div className={`modalContainer`} >
      
        <div className="leftImg">
          <img src={fantacy} alt="" />
        </div>
        <div className="paymentContainer">
          <div className="content">
            <p>Do You Want a credit to purchase Images?</p>
          </div>
          <div>
            <h5 className="subText"> Enter Purchase Amount</h5>
          </div>
          <div className="form-control mb-50" style={{ margingBottom: "0px" }}>
            <input
              value={value}
              onChange={renderValues}
              type="text"
              placeholder="Enter USD Value"
            />
          </div>
          <div className="credit">
            <h5 className="subText"> You will get </h5>
          </div>
          <div>
            <table
              className="table table-dark popTRg"
              style={{
                backgroundColor:
                  "linear-gradient(to right, rgb(254 215 123) 0%, rgba(255, 215, 123, 0.6) 100%)",
              }}
            >
              <thead>
                <tr>
                  <th scope="col">Total Credits</th>
                  <th scope="col">Total Images</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{credit}</td>
                  <td>{image}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="btnSec">
            <button className="btn" onClick={onClose}>
             Return
            </button>
            <button className="btn" onClick={() => buyCredit()}>
              Buy
            </button>
          </div>
          
        </div>
        <div className="modalRight">
            <p onClick={onClose}>X</p>
          </div>
      </div>
    </div>

</>



    
  );
};

export default PaymentModal;
